import React from 'react'
import PropTypes from 'prop-types'
import Select from '@hixme-ui/select'
import { FieldError } from 'components/ReduxFormComponents'
import { hasError } from 'modules/redux-form-utils'

const LocationsDropdown = ({ list, ...props }) => {
  const locations = (list || []).map((loc) => ({
    id: loc.County,
    name: `${loc.County}, ${loc.StateProvince}`,
  }))
  locations.unshift({ id: '', name: 'Select' })

  return (
    <div>
      <Select list={locations} error={hasError(props?.meta)} {...props} />
      {props?.meta?.touched && props?.meta?.error && (
        <FieldError meta={props?.meta} />
      )}
    </div>
  )
}
LocationsDropdown.propTypes = {
  list: PropTypes.array,
}
LocationsDropdown.defaultProps = {
  list: [],
}

export default LocationsDropdown
